import { render } from "./MarketReportDetail.vue?vue&type=template&id=a9c75504&scoped=true"
import script from "./MarketReportDetail.vue?vue&type=script&lang=js"
export * from "./MarketReportDetail.vue?vue&type=script&lang=js"

import "./MarketReportDetail.vue?vue&type=style&index=0&id=a9c75504&lang=css"
import "./MarketReportDetail.vue?vue&type=style&index=1&id=a9c75504&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9c75504"]])

export default __exports__